import { ApiData, Config, FunnelType } from 'scenes/common/types';
import { makeApiSuccess } from 'scenes/common/helpers/apiData';
import { WireConfigResponse, WireConfigItem, WireConfigName } from './types';

export const unmarshalMaintenanceBanner = (
  configItems: WireConfigItem[]
): boolean =>
  Boolean(
    configItems.find(
      (element) => element.name === WireConfigName.MaintenanceBanner
    )?.config.isEnabled
  );

export const unmarshalMaintenanceType = (
  configItems: WireConfigItem[]
): boolean =>
  Boolean(
    configItems.find(
      (element) => element.name === WireConfigName.MaintenanceBanner
    )?.config.ccMaintenance
  );

export const unmarshalMaintenanceProducts = (
  configItems: WireConfigItem[]
): FunnelType[] =>
  configItems.find(
    (element) => element.name === WireConfigName.MaintenanceBanner
  )?.config.productsUnderMaintenance || [];

export const unmarshalEffectiveEndDate = (
  configItems: WireConfigItem[]
): string =>
  configItems.find(
    (element) => element.name === WireConfigName.EffectiveEndDate
  )?.config.effectiveEndDate || '';

export const unmarshalConfigResponse = (
  response: WireConfigResponse
): ApiData<Config> =>
  makeApiSuccess({
    underMaintenance: unmarshalMaintenanceBanner(response.items),
    ccMaintenance: unmarshalMaintenanceType(response.items),
    productsUnderMaintenance: unmarshalMaintenanceProducts(response.items),
    effectiveEndDate: unmarshalEffectiveEndDate(response.items),
  });
